import { createContext, useContext } from "react";

interface IAuthContext {
    showAuthModal: (url?: string) => void;
}

const initialValue: IAuthContext = {
    showAuthModal: () => {
        /** DO NOTHING */
    },
};

const AuthModalWrapperContext = createContext(initialValue);

export const useAuthModalWrapperContext = () => useContext(AuthModalWrapperContext);

export default AuthModalWrapperContext;
